import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(-2),
  },
  row: {
    padding: `${theme.spacing(3, 0)} !important`,
  },
  currency: {
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontSize: '14px',
  },
  price: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'right',
    fontSize: '16px',
    lineHight: '24px',
  },
  cellText: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  titleRight: {
    textAlign: 'right',
  },
  tableHead: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    backgroundColor: theme.palette.bgPrimary.main,
    boxShadow: `0px -1px 0px 0px ${theme.palette.dividerV2.main} inset`,
    borderBottom: 'none',
    '&.MuiTableCell-root': {
      lineHeight: '1.5rem',
    },
    '&.MuiTableCell-root .MuiFormControlLabel-root': {
      margin: `${theme.spacing(0)} !important`,
    },
  },
  editableAmount: {
    display: 'flex',
    justifyContent: 'end',
  },
  amountInput: {
    width: '90%',
    '& input': {
      textAlign: 'end',
    },
  },
}))
